import { MessageBox } from 'element-ui';
import { checkFileScope } from '@/services/api';
import speedIcon from '@/assets/img/file-scope/speed.svg';
import secureIcon from '@/assets/img/file-scope/secure.svg';
import stableIcon from '@/assets/img/file-scope/stable.svg';

let activeFileScopeModal: Promise<void> | null = null;

function renderCard(icon: string, title: string, description: string): string {
  return `
    <div class="file-scope-card">
      <img class="file-scope-card-icon" src="${icon}" alt="" />
      <div class="file-scope-card-name">${title}</div>
      <div class="file-scope-card-desc">${description}</div>
    </div>
  `;
}

function showFileScopeUpgradeModal(authUrl?: string): Promise<void> {
  if (activeFileScopeModal) {
    return activeFileScopeModal;
  }

  activeFileScopeModal = (async () => {
    let authorize = false;
    try {
      await MessageBox.confirm(
        `
          <div class="file-scope-content">
            <p class="file-scope-subtitle">CartSee 已升级图片托管，营销图片将自动同步至您的建站平台并通过 CDN 加速分发</p>
            <div class="file-scope-cards">
              ${renderCard(speedIcon, '加载更快', '全球 CDN 节点加速')}
              ${renderCard(secureIcon, '数据更安全', '存储在您自己平台')}
              ${renderCard(stableIcon, '操作不变', '一切自动完成')}
            </div>
            <p class="file-scope-steps-title">完成升级仅需两步</p>
            <p class="file-scope-step">1. 点击下方「去授权」，在 CartSee 中完成文件读写权限授权</p>
            <p class="file-scope-step">2. 前往您的建站平台，完成更新操作即可</p>
          </div>
        `,
        '图片托管服务升级',
        {
          customClass: 'file-scope-upgrade-modal',
          confirmButtonText: '去授权',
          cancelButtonText: '取消',
          showCancelButton: true,
          showClose: true,
          closeOnClickModal: true,
          closeOnPressEscape: true,
          dangerouslyUseHTMLString: true,
          distinguishCancelAndClose: true,
        }
      );
      authorize = true;
    } catch (action) {
      // 取消、关闭或点击遮罩时保持原有行为：继续本次上传。
      return;
    }

    if (authorize) {
      if (authUrl) {
        window.open(authUrl, '_blank', 'noopener,noreferrer');
      }
      // 去授权后中止本次上传，授权完成后由用户重新选择图片。
      throw {
        handled: true,
        message: '当前未授权 CartSee 文件读写权限',
      };
    }
  })();

  return activeFileScopeModal.finally(() => {
    activeFileScopeModal = null;
  });
}

/**
 * 网站弹窗图片上传前校验建站平台文件权限。
 * 已授权或用户取消提示时继续；点击“去授权”时拒绝 Promise，阻止本次上传。
 */
export async function ensureFileScopeAuthorized(): Promise<void> {
  const res = await checkFileScope({});
  if (res?.data?.data?.authorized) {
    return;
  }

  await showFileScopeUpgradeModal(res?.data?.data?.authUrl);
}
